import React, { cloneElement, isValidElement } from 'react';
import styles from '../styles.module.css';
import PageCard from '@/components/general/PageCard';
import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';

export default function SearchSectionHead({
  item,
  href,
  className = '',
  linkColor = '',
}: {
  item?: any;
  href?: string;
  className?: string;
  linkColor?: string;
}) {
  return (
    <PageCard
      className={`${styles.pageCard} ${className}`}
      title={
        <>
          {item?.title}{' '}
          {item?.count && <span className={`${styles.count}`}> {item?.count} نتیجه</span>}
        </>
      }
      icon={
        isValidElement(item?.icon)
          ? cloneElement(item?.icon, {
              fill: item?.iconColor,
              width: `${'16px'}`,
              height: `${'16px'}`,
            })
          : item?.icon
      }
      noIconWidth={!item?.icon}
      backgroundIcon={item?.backgroundIcon}
      aside={
        <AppLink
          title={item?.title}
          href={href}
          className={`${styles.moreButton}`}
          style={{ color: linkColor || 'var(--accent)' }}
        >
          {item?.moreText}
          <MainIcons.arrowIcon
            fill={linkColor ? linkColor : 'var(--accent)'}
            width="11px"
            height="11px"
            className={`rotateIcon-rtl`}
          />
        </AppLink>
      }
    />
  );
}
